import React from 'react';
import Button from 'react-bootstrap/Button';

import { tsDifferenceInSecs, removeDecimalsFromSecs, getRealTimeActualSeconds } from '../../../../../helpers/helpers';
import { LIVE_PRACTICE, PAST_GAME } from '../../../../../config/constants';
import { ActionButtons } from '../../types';

export default ({ 
  onPlay, setOnPlay, isNowLive, currentSec, practiceData, currentPeriodIndex, onClickEventsDispatcher 
} : ActionButtons) => {

  const goToPrevPeriod = (status: number) => {
    const { drills, startTime } = practiceData;
    if (drills && drills.length && status < 0) {
      const { startTs } = drills[currentPeriodIndex];
      const actualSeconds = removeDecimalsFromSecs(currentSec);
      const difTime = actualSeconds - tsDifferenceInSecs(startTime, startTs);
      
      if (difTime > 3) return currentPeriodIndex;
    }

    return currentPeriodIndex + status < 0 ? 0 : currentPeriodIndex + status;
  };

  const prevNextButtonHandler = (status: number) => {
    const { drills, startTime } = practiceData;
    const updatedPeriod = goToPrevPeriod(status);
    const { startTs } = (drills && drills.length && drills[updatedPeriod]) || {};
    if (startTs && updatedPeriod < drills.length && updatedPeriod >= 0) {
      const periodInSecs = tsDifferenceInSecs(startTime, startTs);
      onClickEventsDispatcher(periodInSecs, updatedPeriod);
    } else if (drills && drills.length && practiceData.type === LIVE_PRACTICE && !isNowLive) { 
      // go live if it's live practice and there are no periods ahead
      const { actualSeconds } = getRealTimeActualSeconds(practiceData.startTime);
      onClickEventsDispatcher(removeDecimalsFromSecs(actualSeconds));
      setOnPlay(true);
    }
  };

  const handleOnReset = () => {
    setOnPlay(false);
    onClickEventsDispatcher(0, 0);
  };

  const handleOnLiveClick = () => {
    const { actualSeconds } = getRealTimeActualSeconds(practiceData.startTime);
    setOnPlay(true);
    onClickEventsDispatcher(removeDecimalsFromSecs(actualSeconds));
  };

  return (
    <>
      {practiceData.type !== PAST_GAME && (
        <>
          <Button onClick={() => prevNextButtonHandler(-1)}><i className="mdi mdi-skip-previous"></i>Prev</Button>
          <Button onClick={() => prevNextButtonHandler(1)}><i className="mdi mdi-skip-next"></i>Next</Button>
        </>)}
      {onPlay ?
        <Button onClick={() => setOnPlay(false)}>
          <i className="mdi mdi-pause"></i>Pause
              </Button>
        :
        <Button onClick={() => setOnPlay(true)}>
          <i className="mdi mdi-play"></i>Play
        </Button>
      }
      <Button onClick={handleOnReset}><i className="mdi mdi-refresh"></i>Reset</Button>
      {practiceData && (practiceData.type === LIVE_PRACTICE || practiceData.type === PAST_GAME)  && (
        <Button onClick={handleOnLiveClick}><i className="mdi mdi-record"></i>Live</Button>
      )}
    </>
  );
};
